"use strict";

exports.__esModule = true;
exports.isMemberAreaActive = void 0;

var _appsConfig = require("@wix/communities-forum-universal/dist/src/constants/appsConfig");

var _communitiesContextSelectors = require("./communities-context-selectors");

var isMemberAreaActive = function isMemberAreaActive(state) {
  return (0, _communitiesContextSelectors.getApplicationConfig)(state, _appsConfig.SANTA_MEMBERS_APP_ID).isInstalled;
};

exports.isMemberAreaActive = isMemberAreaActive;